import { useTranslation } from '@web_opxp/features';
import React from 'react';

interface ICountryButtonProps {
  id: string;
  name: string;
  onSelect: (id: string) => void;
}

const CountryButton: React.FC<ICountryButtonProps> = ({ id, name, onSelect }) => {
  const { t } = useTranslation();
  const title = t(`countries:${id}`) || name;
  const flagIconClass = `flag-icon flag-icon-${id.toLowerCase()}`;
  const selectHandler = () => onSelect(id);
  return (
    <div className="country">
      <span className="country-button" onClick={selectHandler}>
        <span className={flagIconClass}></span>
        {title}
      </span>
    </div>
  );
};

export default CountryButton;
